import { checkExpiredHoldsAndNotify } from '../services/unitHoldBook.job';
import { scheduleIstTask } from './cron.service';

export const initUnitHoldBookCron = () => {
  // Runs every day at 9:00 AM IST
  scheduleIstTask(
    '0 9 * * *',
    checkExpiredHoldsAndNotify,
    'Expired unit holds checked and notifications sent',
  );
};
